import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { WidgetTypes, SectionTypes, widgetTypeToUserText } from '../../../../common/types/api/report'
import { ComponentCardForm } from '../../../../common/types/cardForm'

import '../emailType/gallery'
import '../emailType/html'
import '../emailType/text'

import { getTypes, getWrapper, getContentTypes } from '../wrapperDecorator'
import Wrapper from '../Wrapper'
import { TrashButton } from '../../../../common/components/actions/trashBtn'
import { Edit } from '../../../../common/components/actions/edit'

import { PropsWidgetWrapper } from '../types'
import { getWidgetPage } from '../helper/getWidgetPage'
import { updateWidgetPage } from '../helper/updateWidgetPage'
import { addPipes } from '../helper/addPipes'
import { addHtml } from '../helper/addHtml'
import { addGallery } from '../helper/addGallery'
import { decodeLabel } from '../helper/decodeLabel'
import { PropsFilesPdfWrapper } from './types'
import { pdfGetFirstOrCreate } from './getPdf'
import { getNextId } from '../getNextId'
import { DropDownGallery } from '../../../../common/components/DropDownGallery'
import { ConfigLookupReplicationButton } from '../../../../common/components/ConfigLookupReplicationButton'
import { CustomToolTip } from '../../../../common/components/CustomToolTip/CustomToolTip'
import i18n from 'live/services/i18n'
import { Galleries } from '../../../../common/types/api/page'
import { Dropdown, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { EmptyReportContainer, SectionHeaderContainer } from '../LayoutGallery'
import getLookups from '../../../../api/getLookups'

export function LayoutGallery({
    editMode,
    formObject,
    onChange
}: ComponentCardForm<PropsFilesPdfWrapper>): JSX.Element {
    const { files, page } = formObject
    const pdf = pdfGetFirstOrCreate(files)
    const { layout, fileName, size } = pdf
    const [openEditor, setOpenEditor] = useState<number>(-1)
    const [showBtnAdd, setShowBtnAdd] = useState<boolean>(false)

    const [lookupMap, setLookupMap] = useState<Map<string, string>>(new Map())

    const { blocksHtml = [], blocksPipes = [], galleries = [], snippets = { css: [], js: [] } } = page

    function getGallery(type: WidgetTypes, id: number): Galleries {
        if (type === WidgetTypes.GALLERY) return galleries.find(block => block.id === id) as Galleries
        return {} as Galleries
    }

    function leadingZeros(places: number, num: number) {
        return String(num).padStart(places, '0')
    }

    const handleFetchMacroName = async () => {
        const data = await getLookups()
        data.forEach(el => {
            lookupMap.set(el.id, el.name)
        })
    }

    const handleGetLookupByMacro = (value: string): string => {
        return lookupMap.get(value)
    }

    useEffect(() => {
        handleFetchMacroName()
    }, [])

    return (
        <div>
            {layout.length > 0 ? (
                <div
                    style={{
                        minHeight: 96,
                        paddingBottom: 16
                        //  overflowY: 'auto' // causing dropdown menu not overflow outisde div
                    }}
                >
                    {layout.map(({ type, id }, index) => {
                        const isFirst = index === 0
                        const isLast = index + 1 === layout.length
                        if (!type) return null
                        const content = getWidgetPage(id, type, page)

                        const wrapper = getWrapper(type)

                        const gallery = getGallery(type, id)
                        const replication = gallery?.replication
                        const galleryReplicationIsActive = replication?.active || false
                        const galleryReplicationLookups = replication?.lookups
                        const galleryLookupTemplate = replication?.lookups[0]?.macro || ''
                        const isLookupEmpty =
                            gallery?.replication?.lookups[0]?.macro === '' ||
                            gallery?.replication?.lookups[0]?.macro === undefined

                        return (
                            <WrapperContainer key={`report-chart-${id}`} editMode={editMode}>
                                <div className="gallery-row">
                                    <SectionHeaderContainer
                                        isGalleryMode={type === WidgetTypes.GALLERY}
                                        isTemplateEnable={galleryReplicationIsActive}
                                        noLookup={isLookupEmpty}
                                        editMode={editMode}
                                    >
                                        <label className="gallery-row-title">
                                            SECTION {leadingZeros(2, index + 1)} - {decodeLabel(type).toUpperCase()}
                                        </label>
                                        {!isLookupEmpty ? (
                                            <div className="templateUsed">
                                                <CustomToolTip
                                                    hasIcon={false}
                                                    tooltip={`${i18n(
                                                        'This section is being used as a template for the automatic replication of the'
                                                    )} "${handleGetLookupByMacro(galleryLookupTemplate)}" ${i18n(
                                                        'values within its layout. Change it in the options menu.'
                                                    )}`}
                                                    widthInPX={250}
                                                    delayShow={500}
                                                >
                                                    <div className="templatedUsedText">
                                                        <i className="far fa-check" />{' '}
                                                        {i18n('Being used as template to')}
                                                        {' "'}
                                                        {handleGetLookupByMacro(galleryLookupTemplate)}
                                                        {'"'}
                                                    </div>
                                                </CustomToolTip>
                                            </div>
                                        ) : isLookupEmpty ? (
                                            <div className="templateNotUsed">
                                                <CustomToolTip
                                                    hasIcon={false}
                                                    tooltip={i18n(
                                                        'You must select a lookup for its values to be replicated in a template. Go to the options menu and click on the “Use section as template” item to set it.'
                                                    )}
                                                    widthInPX={250}
                                                    delayShow={500}
                                                >
                                                    <div className="templateNotUsedText">
                                                        <i className="far fa-empty-set" />{' '}
                                                        {i18n(
                                                            'empty-set Being used as template to “No lookup" selected'
                                                        )}
                                                    </div>
                                                </CustomToolTip>
                                            </div>
                                        ) : null}
                                        {editMode && (
                                            <div className="options-button">
                                                <DropDownGallery title={i18n('Options')}>
                                                    <DropdownIconOption
                                                        className="options-button--option"
                                                        disabled={isFirst}
                                                        onClick={() => {
                                                            if (index !== 0) {
                                                                const newLayout = [...layout]
                                                                const aux = { ...newLayout[index] }

                                                                if (newLayout[index - 1] && aux) {
                                                                    newLayout[index] = newLayout[index - 1]
                                                                    newLayout[index - 1] = aux
                                                                }

                                                                onChange({
                                                                    page,
                                                                    files: [
                                                                        {
                                                                            layout: newLayout,
                                                                            fileName: fileName,
                                                                            size: size
                                                                        }
                                                                    ]
                                                                })
                                                            }
                                                        }}
                                                    >
                                                        <Edit
                                                            className="far fa-chevron-up"
                                                            style={{
                                                                lineHeight: 0,
                                                                padding: '1px 0px'
                                                                // color: index === 0 ? '#364159' : undefined
                                                            }}
                                                        ></Edit>
                                                        <span>{i18n('Move up')}</span>
                                                    </DropdownIconOption>
                                                    <DropdownIconOption
                                                        className="options-button--option"
                                                        disabled={isLast}
                                                        onClick={() => {
                                                            if (index + 1 !== layout.length) {
                                                                const newLayout = [...layout]
                                                                const aux = { ...newLayout[index] }

                                                                if (newLayout[index + 1] && aux) {
                                                                    newLayout[index] = newLayout[index + 1]
                                                                    newLayout[index + 1] = aux
                                                                }

                                                                onChange({
                                                                    page,
                                                                    files: [
                                                                        {
                                                                            layout: newLayout,
                                                                            fileName: fileName,
                                                                            size: size
                                                                        }
                                                                    ]
                                                                })
                                                            }
                                                        }}
                                                    >
                                                        <Edit
                                                            className="fa fa-chevron-down"
                                                            style={{
                                                                lineHeight: 0,
                                                                padding: '1px 0px'
                                                            }}
                                                        ></Edit>
                                                        <span>{i18n('Move down')}</span>
                                                    </DropdownIconOption>
                                                    {type === WidgetTypes.GALLERY ? (
                                                        <DropdownIconOption
                                                            className="options-button--option"
                                                            disabled={false}
                                                        >
                                                            <ConfigLookupReplicationButton
                                                                active={galleryReplicationIsActive}
                                                                lookup={
                                                                    galleryReplicationLookups?.length > 0
                                                                        ? galleryReplicationLookups[0]
                                                                        : undefined
                                                                }
                                                                onChange={(active, lookup) => {
                                                                    const galleryIdx = galleries.findIndex(
                                                                        ({ id: _id }) => _id === id
                                                                    )
                                                                    if (gallery && galleryIdx >= 0) {
                                                                        const currentGallery = galleries[galleryIdx]
                                                                        onChange({
                                                                            files: [
                                                                                {
                                                                                    fileName: fileName,
                                                                                    layout: layout,
                                                                                    size: size
                                                                                }
                                                                            ],
                                                                            page: {
                                                                                ...page,
                                                                                galleries: [
                                                                                    ...galleries.slice(0, galleryIdx),
                                                                                    {
                                                                                        ...currentGallery,
                                                                                        replication: {
                                                                                            active:
                                                                                                active !== undefined
                                                                                                    ? active
                                                                                                    : currentGallery
                                                                                                        ?.replication
                                                                                                        ?.active || false,
                                                                                            lookups:
                                                                                                lookup !== undefined
                                                                                                    ? [lookup]
                                                                                                    : currentGallery
                                                                                                        ?.replication
                                                                                                        ?.lookups
                                                                                        }
                                                                                    },
                                                                                    ...galleries.slice(galleryIdx + 1)
                                                                                ]
                                                                            }
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                        </DropdownIconOption>
                                                    ) : null}
                                                    <DropdownIconOption className="options-button--trash" disabled={false}>
                                                        <TrashButton
                                                            label={i18n('Delete')}
                                                            contentIdentifier={`Section type ${widgetTypeToUserText(type)}, id ${id}`}
                                                            additonalWarnningMessage={
                                                                type === WidgetTypes.HTML ? 
                                                                i18n(`To reintroduce this type of content, you will need to create a '${widgetTypeToUserText(WidgetTypes.GALLERY)}' type section and include a '${widgetTypeToUserText(WidgetTypes.HTML)}' type content.`)
                                                                : undefined
                                                            }
                                                            className="trashButtonGallery"
                                                            onClick={() => {
                                                                switch (type) {
                                                                    case WidgetTypes.PIPES:
                                                                        onChange({
                                                                            page: {
                                                                                ...page,
                                                                                blocksPipes: blocksPipes.filter(
                                                                                    ({ id: _id }) => _id !== id
                                                                                )
                                                                            },

                                                                            files: [
                                                                                {
                                                                                    layout: layout.filter(
                                                                                        ({ id: _id }) => _id !== id
                                                                                    ),
                                                                                    fileName: fileName,
                                                                                    size: size
                                                                                }
                                                                            ]
                                                                        })
                                                                        break
                                                                    case WidgetTypes.HTML:
                                                                        onChange({
                                                                            page: {
                                                                                ...page,
                                                                                blocksHtml: blocksHtml.filter(
                                                                                    ({ id: _id }) => _id !== id
                                                                                )
                                                                            },
                                                                            files: [
                                                                                {
                                                                                    layout: layout.filter(
                                                                                        ({ id: _id }) => _id !== id
                                                                                    ),
                                                                                    size: size,
                                                                                    fileName: fileName
                                                                                }
                                                                            ]
                                                                        })
                                                                        break
                                                                    case WidgetTypes.GALLERY:
                                                                        onChange({
                                                                            page: {
                                                                                ...page,
                                                                                galleries: galleries.filter(
                                                                                    ({ id: _id }) => _id !== id
                                                                                )
                                                                            },
                                                                            files: [
                                                                                {
                                                                                    layout: layout.filter(
                                                                                        ({ id: _id }) => _id !== id
                                                                                    ),
                                                                                    fileName: fileName,
                                                                                    size: size
                                                                                }
                                                                            ]
                                                                        })
                                                                        break
                                                                }
                                                            }}
                                                        />
                                                    </DropdownIconOption>
                                                </DropDownGallery>
                                            </div>
                                        )}
                                        {/* </div> */}
                                    </SectionHeaderContainer>
                                </div>
                                <Wrapper
                                    onChange={udpatedWidget => {
                                        const newPage = updateWidgetPage(id, udpatedWidget, page)
                                        const newLayout = layout.filter(
                                            ({ type: _type, id: _id }) => !!getWidgetPage(_id, _type, newPage).config
                                        )

                                        onChange({
                                            page: newPage,
                                            files: [
                                                {
                                                    layout: newLayout,
                                                    fileName: fileName,
                                                    size: size
                                                }
                                            ]
                                        })
                                    }}
                                    setOpenEditor={() => setOpenEditor(id)}
                                    setCloseEditor={() => setOpenEditor(-1)}
                                    openEditor={id === openEditor}
                                    content={content}
                                    wrapper={wrapper}
                                    editMode={editMode}
                                />
                            </WrapperContainer>
                        )
                    })}
                </div>
            ) : !editMode ? (
                <EmptyReportContainer>
                    <i className="far fa-file-search mainIcon" />
                    <span className="textTitle">{i18n('Your report has no content yet.')}</span>
                    <span className="textDescription">
                        {i18n('Click the edit button')} ({<i className="far fa-edit" />}) {i18n('to')}{' '}
                    </span>
                    <span className="textDescription">{i18n('start creating it.')} </span>
                </EmptyReportContainer>
            ) : null}
            <div
                style={{
                    height: editMode ? '50px' : '100px',
                    marginTop: '5px',
                    // border: 'solid 1px #c2c2c2',
                    padding: '10px 10px',
                    position: 'relative',
                    display: editMode ? 'flex' : 'none',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <ContentDropDown>
                    <ContentDropDownButton id="sectionDropdown" pullRight>
                        <ContentDropDownButton.Toggle>
                            <CustomToolTip
                                hasIcon={false}
                                placement="top"
                                delayShow={500}
                                widthInPX={250}
                                textAlign="center"
                                tooltip={
                                    <span style={{ color: 'var(--gray-0)' }}>
                                        {i18n('Insert sections into your report.')}
                                        <br /> {i18n('By using sections, you can organize')}
                                        <br /> {i18n('and present information, tailoring it')}
                                        <br /> {i18n('within its respective context.')}
                                    </span>
                                }
                            >
                                <div className="toggleTooltipTrigger">
                                    <i className="far fa-plus" />
                                    <span>{i18n('Add Section')}</span>
                                </div>
                            </CustomToolTip>
                        </ContentDropDownButton.Toggle>
                        <Dropdown.Menu>
                            {getContentTypes().map(type => {
                                const decodeLabelBtn = (type: SectionTypes): JSX.Element => {
                                    switch (type) {
                                        case SectionTypes.PIPES:
                                            return (
                                                <div className="baseMenuItem">
                                                    <span className="contentMenuItem">
                                                        <i className="far fa-code" />
                                                        {i18n('HTML Only')}
                                                    </span>
                                                </div>
                                            )

                                        case SectionTypes.GALLERY:
                                            return (
                                                <div className="baseMenuItem">
                                                    <span className="contentMenuItem">
                                                        <i className="far fa-th-large" />
                                                        {i18n('Gallery')}
                                                    </span>
                                                </div>
                                            )
                                    }
                                }

                                return (
                                    <ContentDropDownItem
                                        key={`config-type-${type}`}
                                        onClick={() => {
                                            const id = getNextId(page)
                                            switch (type) {
                                                case WidgetTypes.PIPES:
                                                    onChange({
                                                        files: [
                                                            {
                                                                fileName: fileName,
                                                                layout: [
                                                                    ...layout,
                                                                    {
                                                                        id,
                                                                        type
                                                                    }
                                                                ],
                                                                size: size
                                                            }
                                                        ],
                                                        page: {
                                                            ...page,
                                                            blocksPipes: [...blocksPipes, addPipes(id)]
                                                        }
                                                    })
                                                    break
                                                case WidgetTypes.HTML:
                                                    onChange({
                                                        files: [
                                                            {
                                                                fileName: fileName,
                                                                layout: [
                                                                    ...layout,
                                                                    {
                                                                        id,
                                                                        type
                                                                    }
                                                                ],
                                                                size: size
                                                            }
                                                        ],
                                                        page: {
                                                            ...page,
                                                            blocksHtml: [...blocksHtml, addHtml(id)]
                                                        }
                                                    })
                                                    break
                                                case WidgetTypes.GALLERY:
                                                    onChange({
                                                        files: [
                                                            {
                                                                fileName: fileName,
                                                                layout: [
                                                                    ...layout,
                                                                    {
                                                                        id,
                                                                        type
                                                                    }
                                                                ],
                                                                size: size
                                                            }
                                                        ],
                                                        page: {
                                                            ...page,
                                                            galleries: [...galleries, addGallery(id)]
                                                        }
                                                    })
                                                    break
                                            }
                                        }}
                                    >
                                        <CustomToolTip
                                            hasIcon={false}
                                            tooltip={`${
                                                type === WidgetTypes.GALLERY
                                                    ? 'Gallery section comports the three types of content: Widgets, Text and HTML.'
                                                    : 'HTML section comports HTML Only content.'
                                            }`}
                                            widthInPX={165}
                                            delayShow={500}
                                        >
                                            {decodeLabelBtn(type)}
                                        </CustomToolTip>
                                    </ContentDropDownItem>
                                )
                            })}
                        </Dropdown.Menu>
                    </ContentDropDownButton>
                </ContentDropDown>
            </div>
        </div>
    )
}
const WrapperContainer = styled.div<{ editMode: boolean }>`
    margin: 20px 20px 0;
    border-radius: 4px;
    border: solid 1px #c8ccd4;
    background: ${({ theme }) => theme.white};
    /* ${({ theme, editMode = false }) => {
        if (editMode) {
            return `background: ${theme['gray-0']}`
        }
    }} */

    .gallery-row {
        height: 34px;
        padding: 0px 10px 24px;
        margin-bottom: 16px;
        border-radius: 4px;

        .gallery-row-title {
            display: inline;
            color: var(--gray-700);
            font-family: ${({ theme }) => theme['font-semibold']} !important;
            font-size: 13px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px; /* 123.077% */
            letter-spacing: 0.65px;
            height: 26px;
        }
    }

    .options-button {
        display: flex;
        gap: 5px;
        height: 24px;
        /* float: right; */
        justify-content: flex-end;
        margin-right: 10px;
        i {
            line-height: 15px;
        }
        &--trash {
            :hover {
                i {
                    color: var(--red-500) !important;
                }
                span {
                    font-weight: 600;
                }
            }
        }
    }
`

const DropdownIconOption = styled.div<{ disabled: boolean }>`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    padding: 8px 0px;
    vertical-align: middle;
    font-family: var(--font-regular) !important;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

    .trashButtonGallery {
        width: 100% !important;
        line-height: 0;
        gap: 8px;
        display: flex;
        align-items: center;
        color: var(--gray-400);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 14px;
        height: 16px;

        span {
            display: flex;
            gap: 8px;
            color: var(--gray-800);
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
        }
        i {
            color: var(--gray-600);
            padding: 0px !important;
        }
    }

    i {
        margin-left: 16px;
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme['gray-600']};

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 14px;
        height: 16px;
    }

    span {
        color: ${({ theme, disabled }) => theme[disabled ? 'gray-500' : 'gray-800']};
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
    }

    :hover {
        i {
            color: ${({ disabled }) => (disabled ? 'var(--gray-500)' : 'var(--blue-700)')};
        }

        span {
            font-family: ${({ theme }) => theme['font-semibold']};
            font-size: 13px;
            font-style: normal;
            line-height: 16px;
            color: ${({ disabled }) => (disabled ? 'var(--gray-500)' : 'var(--gray-800)')};
            font-weight: ${({ disabled }) => (disabled ? '400' : '600')};
        }
    }
`

const ContentDropDown = styled.div`
    .dropdown-toggle {
        display: flex !important;
        justify-content: space-around !important;
        align-items: center !important;
        background: transparent;
        min-width: 157px;
        height: 32px;
        font-family: ${({ theme }) => theme['font-semibold']} !important;
        font-weight: 600;
        color: ${({ theme }) => theme['blue-500']};
        border: 1px solid ${({ theme }) => theme['blue-500']};
        border-radius: 3px;
    }

    .open > .btn-default.dropdown-toggle,
    .dropdown-toggle:focus,
    .dropdown-toggle:hover {
        background: transparent;
        font-family: ${({ theme }) => theme['font-semibold']} !important;
        color: ${({ theme }) => theme['blue-700']};
        box-shadow: none;
        border: 1px solid ${({ theme }) => theme['blue-700']};
        border-radius: 3px;
    }

    .dropdown-menu {
        margin: 0;
        padding: 0;
        margin-top: 4px;
        min-width: 185px;
        border-radius: 4px;
        overflow: hidden;
    }

    .divider {
        height: 1px;
    }
`

const ContentDropDownButton = styled(Dropdown)`
    background: ${({ theme }) => theme['gray-100']};
    font-family: ${({ theme }) => theme['font-semibold']} !important;

    .toggleTooltipTrigger {
        width: 100%;
        i {
            padding-right: 12px;
        }
    }
`

const ContentDropDownItem = styled(MenuItem)`
    height: 38px;

    a {
        padding: 0 !important;
        height: 100%;

        .baseMenuItem {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;

            .contentMenuItem {
                font-family: ${({ theme }) => theme['font-regular']} !important;
                font-weight: 400 !important;
                color: ${({ theme }) => theme['gray-800']};

                i {
                    color: ${({ theme }) => theme['gray-600']};
                    padding: 8px 8px 8px 16px;
                }
            }

            :hover {
                .contentMenuItem {
                    font-family: ${({ theme }) => theme['font-semibold']} !important;
                    font-weight: 600 !important;
                    color: ${({ theme }) => theme['gray-800']};

                    i {
                        color: ${({ theme }) => theme['blue-500']};
                    }
                }
            }
        }
    }
`
